import React from "react"
import PropTypes from "prop-types"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import sheetConstants from "app/static/frontend/sheets/constants"

// Render the button in Sheets that allows users to resize the rows of a sheet
export const ResizeRowsTrigger = ({ rowHeightFactor, id, editSheet, patchSheet }) => {
    // resize handlers
    const handleRowSizeChange = async (increment = true) => {
        // keep track of whether we are incrementing or decrementing
        const newRowHeightFactor = { row_height_factor: rowHeightFactor + (increment ? 1 : -1) }
        // edit the sheet in the store
        editSheet(id, newRowHeightFactor)

        // send a network request to update the row height
        await patchSheet(id, newRowHeightFactor)
    }
    const handleIncreaseRowSize = () => handleRowSizeChange()
    const handleDecreaseRowSize = () => handleRowSizeChange(false)

    return (
        <div className="resize-rows-trigger">
            {rowHeightFactor < sheetConstants.MAX_ROW_HEIGHT_FACTOR && (
                <Tooltip label="Click to increase the size of your sheet's rows. You can click multiple times.">
                    <div>
                        <Icon name="fa-expand" onClick={handleIncreaseRowSize} data-cy="cy-expand-icon" />
                    </div>
                </Tooltip>
            )}
            {rowHeightFactor > 1 && (
                <Tooltip label="Click to decrease the size of your sheet's rows">
                    <div>
                        <Icon name="fa-compress" onClick={handleDecreaseRowSize} data-cy="cy-compress-icon" />
                    </div>
                </Tooltip>
            )}
        </div>
    )
}

ResizeRowsTrigger.propTypes = {
    id: PropTypes.string.isRequired, // this is the sheetKey of the form "sheet:2030"
    rowHeightFactor: PropTypes.number.isRequired,
    patchSheet: PropTypes.func.isRequired,
    editSheet: PropTypes.func.isRequired,
}

export default ResizeRowsTrigger
